import React from 'react';
import { Link } from 'react-router-dom';
import PixelIcon from './PixelIcon';

const RoadmapIsland = ({ item }) => {
  return (
    <div className="roadmap-island">
      <div className="roadmap-island-content">
        <div className="roadmap-island-header">
          <PixelIcon status={item.status} />
          <h3 className="roadmap-island-title">{item.title}</h3>
        </div>
        <p className="roadmap-island-desc">{item.desc}</p>
        {item.quarter && (
          <p className="roadmap-island-quarter">{item.quarter}</p>
        )}
        {item.link && (
          <Link to={item.link} className="roadmap-island-link">
            Details
          </Link>
        )}
      </div>

      {/* island sprite */}
      <div className="roadmap-island-sprite" aria-hidden />
    </div>
  );
};

export default RoadmapIsland;

